// extracted by mini-css-extract-plugin
module.exports = {"container":"doctorCreateSchedulePage_container__2CbNy","title":"doctorCreateSchedulePage_title__oLSf6","subtitle":"doctorCreateSchedulePage_subtitle__5e44e"};